<script setup lang="ts">
import { computed } from 'vue';

import {
  GrammarDivider,
  GrammarLocalLoader,
} from '@nora-monorepo/grammar-ui';
import { useWebViewStore } from '@nora-monorepo/ui-shared';

import BaseMapLayersView from '#nora-ui/map/components/overlay-menu/BaseMapLayersView.vue';
import DrawLayersGroup from '#nora-ui/map/components/overlay-menu/groups/DrawLayersGroup.vue';
import ToggleAllLayersVisibility from '#nora-ui/map/components/overlay-menu/groups/ToggleAllLayersVisibility.vue';
import ToggleCluster from '#nora-ui/map/components/overlay-menu/groups/ToggleCluster.vue';
import TracksGroup from '#nora-ui/map/components/overlay-menu/groups/TracksGroup.vue';
import FileLayerMenuItem from '#nora-ui/map/components/overlay-menu/items/FileLayerMenuItem.vue';
import NotificationLayerMenuItem from '#nora-ui/map/components/overlay-menu/items/NotificationLayerMenuItem.vue';
import OverlayMenuFooter from '#nora-ui/map/components/overlay-menu/OverlayMenuFooter.vue';
import MenuGroup from '#nora-ui/map/components/overlay-menu/primitives/MenuGroup.vue';
import { useMapStore } from '#nora-ui/map/stores/map-store';
import { useOperationStore } from '#nora-ui/stores/operation-store';

const props = defineProps<{
  mapId: string;
  operationId: string;
}>();

const { mapId } = props;

const webViewStore = useWebViewStore();
const mapStore = useMapStore();
const operationStore = useOperationStore();
const map = mapStore.getMapByIdOrThrow(mapId);

const operationExists = computed(() => operationStore.getOperation(props.operationId) !== undefined);
</script>

<template>
  <div class="h-full flex flex-col">
    <GrammarLocalLoader v-if="map.ref.isLoading" />

    <template v-else>
      <ToggleAllLayersVisibility :map-id="mapId" />
      <ToggleCluster :map-id="mapId" />
      <GrammarDivider orientation="horizontal" />

      <div class="flex flex-1 flex-col gap-5">
        <template v-if="operationExists">
          <DrawLayersGroup
            :map-id="mapId"
            :operation-id="props.operationId"
          />
          <TracksGroup
            :map-id="mapId"
            :operation-id="props.operationId"
          />
        </template>

        <MenuGroup title="Other">
          <FileLayerMenuItem :map-id="mapId" />

          <GrammarDivider
            emphasis="low-emphasis"
            class="px-2"
          />

          <NotificationLayerMenuItem :map-id="mapId" />
        </MenuGroup>

        <BaseMapLayersView
          v-if="webViewStore.isWebView"
          :map-id="mapId"
        />
      </div>
      <div class="sticky -bottom-2">
        <OverlayMenuFooter :map-id="mapId" />
      </div>
    </template>
  </div>
</template>
